import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { Admin } from 'components/Admin'

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/users/:partnerId/*" element={<Admin user={true} />} />
        <Route path="/users/:partnerId" element={<Admin user={true} />} />
        <Route path="/*" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
